import React from 'react';
import FlexBox from '../Box/FlexBox.styled';
import NavbarElement from './NavbarElement.styled';
import Text from '../Text/Text.styled';
import Box from '../Box/Box.styled';

const Navbar = () => {
  return (
    <FlexBox alignItems="center">
      <Text variant="header">Isabelle H Photograhpy</Text>
      <Box marginLeft={3}>
        <NavbarElement>Plants</NavbarElement>
        <NavbarElement>Animals</NavbarElement>
        <NavbarElement>Product</NavbarElement>
        <NavbarElement>Portrait</NavbarElement>
        <NavbarElement>Other</NavbarElement>
      </Box>
    </FlexBox>
  );
};

export default Navbar;
